// Reports crashes in this browser to SVENEX's error log (admin console →
// Errors), so problems people hit show up even when they don't tell us.
// Only the error's text, where it happened and the page path are sent: no
// page content, form values or query strings.

import { apiURL, currentToken, IS_ADMIN } from "./api";

const sent = new Set<string>();
let count = 0;
const MAX_PER_PAGE_LOAD = 10;

// Noise that isn't a SVENEX bug: browser extensions, cross-site scripts the
// browser hides, layout warnings, and a new deploy replacing old files.
function ignorable(message: string, stack: string) {
  return /chrome-extension:|moz-extension:|safari-extension:/.test(stack)
    || message === "Script error." || /ResizeObserver loop/.test(message)
    || /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module/i.test(message);
}

export function reportError(err: unknown, kind: "error" | "rejection" | "render" = "error") {
  try {
    const message = (err instanceof Error ? `${err.name}: ${err.message}` : typeof err === "string" ? err : JSON.stringify(err) ?? String(err)).slice(0, 1000);
    const stack = (err instanceof Error ? err.stack ?? "" : "").slice(0, 6000);
    if (!message || ignorable(message, stack)) return;
    const key = kind + message;
    if (sent.has(key) || count >= MAX_PER_PAGE_LOAD) return;
    sent.add(key);
    count++;
    const headers: Record<string, string> = { "Content-Type": "application/json" };
    const token = currentToken();
    if (token) headers.Authorization = `Bearer ${token}`;
    void fetch(apiURL("/v1/public/client-errors"), {
      method: "POST",
      headers,
      keepalive: true,
      body: JSON.stringify({ app: IS_ADMIN ? "admin" : "app", kind, message, stack, page: window.location.pathname, release: import.meta.env.VITE_RELEASE ?? "" }),
    }).catch(() => undefined);
  } catch {
    // Reporting must never cause another error.
  }
}

window.addEventListener("error", (e) => reportError(e.error ?? e.message, "error"));
window.addEventListener("unhandledrejection", (e) => reportError(e.reason, "rejection"));
